import * as React from 'react';
import * as classnames from 'classnames';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { ContentSpacing } from '@estee/elc-base-theme';

export interface IAverageRating {
    className?: string;
    averageRating?: number;
    numberOfStars: number;
}

const AverageRatingWrapper = styled.span`
    display: inline-block;
    vertical-align: middle;
    margin: 0 ${ContentSpacing.space8};
`;

export const AverageRating = observer((props: IAverageRating) => {
    const classNames = classnames(
        'elc-average-rating-text',
        'js-average-rating-text',
        props.className
    );

    return (
        <AverageRatingWrapper className={classNames}>
            {`${props.averageRating}/${props.numberOfStars}`}
        </AverageRatingWrapper>
    );
});
